var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-wrapper", attrs: { id: "contentWrapper" } },
    [
      _vm.menu === "information"
        ? _c("j-information-view", {
            attrs: {
              "is-multiple-form": _vm.isMultipleForm,
              "form-data": _vm.formData,
              "form-detail": _vm.formDetail
            }
          })
        : _vm.menu === "table"
        ? _c("j-table-view", {
            attrs: {
              "is-multiple-form": _vm.isMultipleForm,
              "form-detail": _vm.formDetail
            }
          })
        : _vm.menu === "table-requestor"
        ? _c("j-table-req-view", {
            attrs: {
              "is-multiple-form": _vm.isMultipleForm,
              "form-detail": _vm.formDetail
            }
          })
        : _vm.menu === "table-approver"
        ? _c("j-table-app-view", {
            attrs: {
              "is-multiple-form": _vm.isMultipleForm,
              "form-detail": _vm.formDetail
            }
          })
        : _vm.menu === "list"
        ? _c("j-list-view", {
            attrs: {
              "is-multiple-form": _vm.isMultipleForm,
              "form-detail": _vm.formDetail
            }
          })
        : _vm.menu === "list-requestor"
        ? _c("j-list-req-view", {
            attrs: {
              "is-multiple-form": _vm.isMultipleForm,
              "form-detail": _vm.formDetail
            }
          })
        : _vm.menu === "list-approver"
        ? _c("j-list-app-view", {
            attrs: {
              "is-multiple-form": _vm.isMultipleForm,
              "form-detail": _vm.formDetail
            }
          })
        : _vm.menu === "calendar"
        ? _c("j-calendar-view", {
            attrs: {
              "is-multiple-form": _vm.isMultipleForm,
              "form-detail": _vm.formDetail
            }
          })
        : _vm.menu === "create"
        ? _c("j-create-view", {
            attrs: {
              "is-multiple-form": _vm.isMultipleForm,
              "form-data": _vm.formData,
              "form-detail": _vm.formDetail
            }
          })
        : !_vm.isMultipleForm && _vm.menu === "detail"
        ? _c("j-detail-view", {
            attrs: {
              "is-multiple-form": _vm.isMultipleForm,
              "form-data": _vm.formData,
              "form-detail": _vm.formDetail
            }
          })
        : _vm.isMultipleForm && _vm.menu === "detail"
        ? _c("j-multiple-detail-view", {
            attrs: {
              "is-multiple-form": _vm.isMultipleForm,
              "form-data": _vm.formData,
              "form-detail": _vm.formDetail
            }
          })
        : _vm.menu === "import"
        ? _c("j-import-view", {
            attrs: {
              "is-multiple-form": _vm.isMultipleForm,
              "form-data": _vm.formData,
              "form-detail": _vm.formDetail
            }
          })
        : _vm.menu === "export"
        ? _c("j-export-view", {
            attrs: {
              "is-multiple-form": _vm.isMultipleForm,
              "form-data": _vm.formData,
              "form-detail": _vm.formDetail
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-771b0fe1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-771b0fe1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/jExperienceManagerViewContent.vue
// module id = null
// module chunks = 